import { createSlice } from "@reduxjs/toolkit";
const x = localStorage.getItem("user")
  ? JSON.parse(localStorage.getItem("user"))
  : "";

const initialState = {
  token: x.token ? x.token : "",
  role: x.role ? x.role : "",
  name: x.name ? x.name : "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      const { token, role, name } = action.payload;
      state.token = token;
      state.role = role;
      state.name = name;
    },

    removeUser(state, action) {
      state.token = "";
      state.role = "";
      state.name = "";
    },
  },
});
export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
